import AutoMatch from './auto-matching';
import CreateConfig from './create';
import DriverLocationsConfig from './driver-locations';
import EditConfig from './edit';
import InspectConfig from './inspect';
import ListUsersConfig from './list-users';
import ManageConfig from './manage';
import MonthlyReportsConfig from './monthly-reports';
import MonthlyPayReportsConfig from './monthly-pay-reports';
import QuotaConfig from './quota';
import SharedConfig from './shared-files';
import SiloConfig from './silos';
import SupplyGeneratorConfig from './supply-generator';
import HaulerPayReportsConfig from './hauler-pay-reports';
import VendorPayReportsConfig from './vendor-pay-reports';
import PoolingConfig from './pooling';
import ListConfig from './list';
import EquityConfig from './equity';
import EmbeddedReportConfig from './embedded-reports';
import ManifestConfig from './manifest';
import TableDocumentationConfig from './table-documentation';
import MemberCenterConfig from './member-center';
import UserManagement from './user-management';
import UserProfile from './user-profile';
import EmbeddedAdminCheckoutReportConfig from './admin-checkout-report-embedded';
import EmbeddedProcessorCheckoutReportConfig from './processor-checkout-report-embedded';
import FuelIntakeConfig from './fuel-intake';
import PailWeightConfig from './pail-weight';
import SiloWashesConfig from './silo-washes';
import ProcessedFluidCommodities from './commodities';
import ScaleReadingsConfig from './scale-readings';
import CDFAReportConfig from './cdfa-report';
import EmbeddedAdminMilkPredictionReportConfig from './admin-milk-prediction-report-embedded';
import EmbeddedAdminSupplyOutlookReportConfig from './admin-supply-outlook-report-embedded';
import EmbeddedAdminContractPerformanceReportConfig from './admin-contract-performance-report-embedded';
import MilkInspectorReportsConfig from './milk-inspectors-report';
import SessionRecordingConfig from './session-recording';
import CDFAMarketingReportConfig from './cdfa-marketing-report';
import DemurrageUploadConfig from './demurrage-upload';

export default [
    ...AutoMatch,
    ...CreateConfig,
    ...DriverLocationsConfig,
    ...EditConfig,
    ...InspectConfig,
    ...ListUsersConfig,
    ...ManageConfig,
    ...MonthlyReportsConfig,
    ...MonthlyPayReportsConfig,
    ...QuotaConfig,
    ...SharedConfig,
    ...SiloConfig,
    ...SupplyGeneratorConfig,
    ...HaulerPayReportsConfig,
    ...PoolingConfig,
    ...ListConfig,
    ...VendorPayReportsConfig,
    ...EquityConfig,
    ...ManifestConfig,
    EmbeddedReportConfig,
    TableDocumentationConfig,
    MemberCenterConfig,
    ...UserManagement,
    EmbeddedAdminCheckoutReportConfig,
    EmbeddedProcessorCheckoutReportConfig,
    FuelIntakeConfig,
    ScaleReadingsConfig,
    PailWeightConfig,
    SiloWashesConfig,
    ProcessedFluidCommodities,
    ...UserProfile,
    CDFAReportConfig,
    CDFAMarketingReportConfig,
    EmbeddedAdminMilkPredictionReportConfig,
    EmbeddedAdminSupplyOutlookReportConfig,
    EmbeddedAdminContractPerformanceReportConfig,
    MilkInspectorReportsConfig,
    SessionRecordingConfig,
    DemurrageUploadConfig,
];
